export const EMPLOYER_REP_ROLES = {
    HR: 'HR',
    NON_HR: 'NON_HR',
    ADMIN: 'EM_REP_ADMIN',
    USER: 'EM_REP_USER',
    HIRING_MANAGER: 'HIRING_MANAGER',
    SALES: 'SALES',
};

export const roleOptions = [
    { value: EMPLOYER_REP_ROLES.HR, label: 'HR_DESCRIPTION' },
    { value: EMPLOYER_REP_ROLES.NON_HR, label: 'NON_HR_DESCRIPTION' },
    { value: EMPLOYER_REP_ROLES.HIRING_MANAGER, label: 'HIRING_MANAGER_DESCRIPTION' },
    { value: EMPLOYER_REP_ROLES.SALES, label: 'SALES_DESCRIPTION' },
];
